import { ModalComponentProps } from 'context';

export interface DocDownloadComponentProps {
  showDischargeInfo?: boolean;
  cognitoId: string;
  onNext?(): void;
}

export type DocDownloadProps = ModalComponentProps<DocDownloadComponentProps>;

export enum docDownloadTypes {
  AGREED = 'AGREED',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  DEFAULT = 'DEFAULT',
  RESET = 'RESET',
}

export type DocDownloadTypes = keyof typeof docDownloadTypes;

export type DocDownloadState = {
  type: DocDownloadTypes;
  icon: React.ReactNode;
  button: string;
  helper: string;
  color: string;
  agreed: boolean;
  url: string;
  filename: string;
};

export type DocDownloadReducer<S extends DocDownloadState = DocDownloadState> =
  (
    state: S,
    action:
      | {
          type: docDownloadTypes.AGREED;
          payload: {
            agreed: boolean;
          };
        }
      | {
          type: docDownloadTypes.ERROR;
          payload: {
            message: string;
          };
        }
      | {
          type: docDownloadTypes.SUCCESS;
          payload: {
            url: string;
            filename: string;
          };
        }
      | {
          type: docDownloadTypes.RESET;
          payload: DocDownloadState;
        }
      | {
          type: Exclude<
            DocDownloadTypes,
            'ERROR' | 'AGREED' | 'SUCCESS' | 'RESET'
          >;
        },
  ) => S;

export interface DocDownloadModalProps {
  cognitoId: string;
  onNext?(): void;
}
